import { medicalApiPaths, medicalsApi } from "../api/medicalsApi";
import { QueryKeys } from "../constants/queryKeys";
import { queryClient } from "../queryClient";

export type ChiefComplaintQuery = {
  encounter?: string;
  subject?: string;
  status?: string | string[];
  category?: string;
};

export const ChiefComplaintManager = {
  getPatientChiefComplaint: (query: ChiefComplaintQuery) => {
    return queryClient.fetchQuery({
      queryKey: [QueryKeys.CHIEF_COMPLAINT, query],
      queryFn: () =>
        medicalsApi.findEntities(query, medicalApiPaths.observations),
    });
  },

  invalidate: () =>
    queryClient.invalidateQueries({
      queryKey: [QueryKeys.CHIEF_COMPLAINT],
    }),
};
